export const getAspectRatio = ({
  width,
  height,
  style,
}: {
  width: string;
  height: string;
  style: CSSStyleDeclaration;
}) => {
  const widthString = width || style.width;
  const heightString = height || style.height;

  if (widthString && heightString) {
    const width = parseFloat(widthString);
    const height = parseFloat(heightString);

    return width / height;
  }

  const aspectRatioString = style.aspectRatio;

  if (aspectRatioString) {
    const [width, height] = aspectRatioString
      .split('/')
      .map((num) => parseFloat(num.trim()));

    return width / height;
  }

  return 16 / 9;
};
